const surveyurl =
  window.location.origin.indexOf("localhost") !== -1
    ? "https://api.narendramodi.in/survey"
    : "https://api.narendramodi.in/survey";
export { surveyurl };
